module.exports = "<div class=\"pull-center\">\r\n    <a class=\"navbar-brand\">\r\n        <div ui-include=\"'../assets/images/logo.svg'\"></div>\r\n        <img src=\"../assets/images/logo.png\" alt=\".\" class=\"hide\">\r\n        <span class=\"hidden-folded inline\">BT</span>\r\n    </a>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/public/brand/brand.component.html
// module id = ./src/app/public/brand/brand.component.html
// module chunks = main